import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";

export default function GuideSection() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] || "en";

  return (
    <section id="guides" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">
            {t("guidesEyebrow")}
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t("guidesTitle")}
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-sm md:text-base text-foreground-600">
            {t("guidesText")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((a) => {
            const c = a.content[lang] || a.content.en;
            return (
              <Link
                key={a.slug}
                to={`/article/${a.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-100">
                  <img
                    src={a.image}
                    alt={c.h1}
                    title={c.h1}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col flex-1 p-5">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                    {c.h1}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                    {c.intro}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap">
                    {t("readMore")}
                    <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}